var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"table-card",attrs:{"shadow":"always"}},[_c('div',[_c('el-empty',{attrs:{"image-size":100,"description":"暂无审批记录"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }